import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Button, Typography } from '@mui/material'
import { Box } from '@mui/system'

import { isDeviceSmall } from '~/constants'
import { path } from '~/routes/path'

const CartEmpty = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const goToMenu = () => {
    navigate(path.indexMenu)
  }

  return (
    <Box marginTop="26%">
      <Typography
        component="h2"
        color={'baseColor.colorText1'}
        fontWeight="500"
        fontSize={isDeviceSmall ? '3rem' : '3.6rem'}>
        {t('descriptions.cart_empty')}
      </Typography>
      <Typography
        component="h2"
        color={'baseColor.colorText1'}
        fontWeight="500"
        fontSize={isDeviceSmall ? '3rem' : '3.6rem'}>
        {t('descriptions.hint_cart_empty')}
      </Typography>
      <Button onClick={goToMenu} sx={styles.btnSeeMenu}>
        {t('actions.see_menu')}
      </Button>
    </Box>
  )
}

export default React.memo(CartEmpty)

const styles = {
  btnSeeMenu: {
    backgroundColor: 'baseColor.colorText1',
    color: 'baseColor.colorText2',
    fontSize: '1.8rem',
    fontWeight: '600',
    marginTop: '14px',
    padding: '8px 20px',
  },
}
